module.exports = function() {
  return new Worker(__webpack_public_path__ + "318d48da92af470601a6.worker.js");
};